<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.Integrations') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template v-slot:default>
                        <router-link :to="{ name: 'AddIntegrations', params: { operation: 'add' } }"
                            class="btn btn-primary">
                            <b-icon icon="plus" class="icon-style"></b-icon>
                            {{ $t('title.addnew') }}
                        </router-link>
                    </template>
                    <template v-slot:cell(services)="{ item }">
                        <div class="d-flex align-items-center">
                            <img :src="getServiceLogo(item.services)" :alt="item.services" height="30em" class="mr-2" />
                        </div>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <b-button variant="Primary" v-b-tooltip.hover title="Delete"  @click="openModal(item.id)">
                            <b-icon variant="danger" icon="trash" class="icon-style"></b-icon>
                        </b-button>
                        <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteModalLabel">{{
                                            $t('title.confirmDeletionIntegrations') }}</h5>
                                    </div>
                                    <div class="modal-body">
                                        {{ $t('title.deleteItemIntegrations') }}
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" @click="closeModal">{{
                                            $t('title.cancel') }}</button>
                                        <button type="button" class="btn btn-danger" @click="deleteItem()">{{
                                            $t('title.yes') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Edit Button -->
                        <b-button variant="Primary" v-b-tooltip.hover title="Edit" 
                            @click="$router.push({ name: 'UpdateIntegrations', params: { id: item.id, operation: 'edit' } })">
                            <b-icon variant="primary" icon="pencil-square" class="icon-style"></b-icon>
                        </b-button>

                        <b-button variant="Primary" @click="navigateToService(item)" v-b-tooltip.hover title="Show Data" >
                            <b-icon variant="info" icon="gear-fill" class="icon-style"></b-icon>
                        </b-button>


                    </template>
                    <template #cell(data)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.data" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ $t(`title.${key}`) }}:</strong>

                                    <span
                                        v-if="key === 'google_service_account_credentials_json' && value && visibleFields[item.id]?.[key]">
                                        <!-- <a :href="value" target="_blank" class="text-primary"> -->
                                        {{ value }}
                                        <!-- </a> -->
                                    </span>

                                    <span v-if="!visibleFields[item.id]?.[key]"></span>
                                    <span v-else v-b-popover.hover.top="value">
                                        {{ key !== 'google_service_account_credentials_json' ? (value.length > 100 ?
                                            value.substring(0, 100) + '...' : value) : '' }}
                                        <b-button variant="light" @click="copyValue(value, item.id, key)" v-if="value">
                                            <b-icon variant="primary" icon="files" class="icon-style"></b-icon>
                                        </b-button>
                                    </span>
                                </span>

                                <!-- Visibility toggle button -->
                                <button @click="toggleVisibility(item.id, key)" class="btn btn-link p-0">
                                    <i :class="visibleFields[item.id]?.[key] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </template>


                    <template v-slot:cell(sync_manually)="{ item }">
                        <b-button variant="primary" class="rounded-circle" @click="syncManually(item.id)">
                            <b-icon icon="cloud-upload" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template v-slot:cell(is_active)="{ item }">
                        <b-button variant="Primary" @click="toggleStatus(item.id, item.is_active)">
                            <b-icon :variant="item.is_active ? 'success' : 'secondary'"
                                :icon="item.is_active ? 'toggle-on' : 'toggle-off'" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap"; // Ensure this import is available in your project
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null
};

const COLUMN_STATE = (self) => [
    { key: 'actions', label: self.$t('title.actions') },
    { key: 'services', label: self.$t('title.services'), sortable: true },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'sync_status', label: self.$t('title.sync_status'), sortable: true },
    // { key: 'failure_reason', label: self.$t('title.failure_reason'), sortable: true },
    { key: 'sync_manually', label: self.$t('title.syncManually') },
    { key: 'updated_at', label: self.$t('title.syncDateTime') },
    { key: 'is_active', label: self.$t('title.status'), sortable: true },
];

export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            listUrl: '/admin/integrations',
            filters: { ...FILTER_FORM },
            showPopup: false,
            modalInstance: null, // Declare modalInstance here
            visibleFields: {},
            selectedItemId: null,

        };
    },
    components: { Breadcrumbs },
    methods: {
        getServiceLogo(service) {
            const logos = {
                "G-suit": require("@/assets/google.png"),
                "Salesforce": require("@/assets/salesforce.png"),
                "ZOHO": require("@/assets/zoho.png"),
                "Monday": require("@/assets/monday.png"),
                "Microsoft 365": require("@/assets/office365.png"),
                "SAP": require('@/assets/sap.png'),
            };
            return logos[service] || require("@/assets/integration.png");
        },
        navigateToService(item) {
            if (item.services === "G-suit") {
                this.$router.push({ name: "G-suitUsers", params: { id: item.id } });
            } else if (item.services === "Microsoft 365") {
                this.$router.push({ name: "Office365Users", params: { id: item.id } });
            } else if (item.services === "Salesforce") {
                if (item.data.product_service === "CRM") {
                    this.$router.push({ name: "SalesforceCrmUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Education Cloud") {
                    this.$router.push({ name: "SalesforceEducationCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Analytics") {
                    this.$router.push({ name: "SalesforceAnalyticsUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Net Zero Cloud") {
                    this.$router.push({ name: "SalesforceNetZeroCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Financial Services Cloud") {
                    this.$router.push({ name: "SalesforceFinancialServicesCloudUsers", params: { id: item.id } });
                } else if (item.data.product_service === "Communications Cloud") {
                    this.$router.push({ name: "SalesforceCommunicationsCloudUsers", params: { id: item.id } });
                }
            } else if (item.services === "Monday") {
                this.$router.push({ name: "MondayCRMContacts", params: { id: item.id } });
            } else if (item.services === "ZOHO") {
                this.$router.push({ name: "ZohoCrmUsers", params: { id: item.id } });
            } else if (item.services === "SAP") {
                this.$router.push({ name: "SAPEmployee", params: { id: item.id } });
            } else {
                this.showToast(this.$t("title.error"), this.$t("title.serviceNotSupported"));
            }
        },
        openModal(id) {
            this.selectedItemId = id;
            const modalElement = document.getElementById("deleteModal");
            this.modalInstance = new Modal(modalElement); // Initialize modal
            this.modalInstance.show();
        },
        closeModal() {
            if (this.modalInstance) {
                this.modalInstance.hide();
            }
        },
        copyValue(value, id, key) {
            if (!value) return;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value)
                    .then(() => {
                        this.showToast(this.$t("title.TextCopied"), this.$t("title.TextCopySuccessfully"), 1);
                    })
                    .catch((error) => {
                        console.error("Clipboard API failed:", error);
                    });
            } else {
                // Fallback for older browsers
                let textarea = document.createElement("textarea");
                textarea.value = value;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand("copy");
                    this.showToast(this.$t("title.TextCopied"), this.$t("title.TextCopySuccessfully"), 1);
                } catch (error) {
                    console.error("Fallback copy failed:", error);
                }
                document.body.removeChild(textarea);
            }
        },
        toggleVisibility(id, key) {
            if (!this.visibleFields[id]) {
                this.$set(this.visibleFields, id, {});
            }
            this.$set(this.visibleFields[id], key, !this.visibleFields[id][key]);
        },
        async deleteItem() {
            if (!this.selectedItemId) {
                console.error("Error: No ID selected for deletion");
                return;
            }

            try {
                await request({
                    method: 'delete',
                    url: `/admin/integrations/${this.selectedItemId}`,
                });

                if (this.modalInstance) {
                    this.modalInstance.hide();
                }

                this.showToast(
                    this.$t("title.integrationsDeleted"),
                    this.$t("title.integrationsDeletedSuccess")
                );

                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },

        async syncManually(id) {
            try {
                await request({
                    method: 'post',
                    url: `/admin/integrations/${id}/sync`,
                });
                this.checkSyncStatus(id);

                this.showToast(this.$t("title.syncStarted"), this.$t("title.syncInitiated"), 1);
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                console.error("Sync failed:", error);
                this.showToast(this.$t("title.error"), this.$t("title.syncFailed"), 0);
            }
        },

        async toggleStatus(id, is_active) {
            try {
                const response = await request({
                    method: 'get',
                    url: `/admin/integrations/change-status/${id}`,
                });

                this.showToast(
                    is_active == 1 ? this.$t("title.integrationsDeactivated") : this.$t("title.integrationsActivated"),
                    is_active == 1 ? this.$t("title.integrationsDeactivatedSuccess") : this.$t("title.integrationsActivatedSuccess"),
                    is_active == 1 ? null : 1
                );
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
        },
        showToast(title, msg, status) {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [msg]);
            const vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: status === 1 ? 'primary' : 'danger',
            });
        },
        async checkSyncStatus(id) {
            let response = await request({ method: 'get', url: `/admin/integrations/${id}/status` });
            // Ensure response and response.data exist before accessing status
            if (response && response.status) {
                if (response.status === 'completed') {
                    this.showToast(this.$t("title.syncCompleted"), this.$t("title.syncFinished"), 1);
                    this.$refs['application-table'].refreshTableData();
                } else {
                    setTimeout(() => this.checkSyncStatus(id), 5000);
                }
            } else {
                console.warn("Invalid API response structure:", response);
            }
        }
    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
